var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000008670(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F6901F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2479 20.1381C22.4124 20.1381 21.5919 20.0074 20.8145 19.7505C20.4335 19.6205 19.9652 19.7397 19.7327 19.9785L18.1981 21.137C16.4185 20.187 15.3223 19.0911 14.3853 17.3248L15.5096 15.8303C15.8017 15.5386 15.9065 15.1124 15.781 14.7126C15.5229 13.931 15.3919 13.111 15.3919 12.2751C15.3919 11.6712 14.9006 11.1799 14.2968 11.1799H11.7904C11.1866 11.1799 10.6953 11.6712 10.6953 12.2751C10.6953 19.1966 16.3263 24.8276 23.2479 24.8276C23.8518 24.8276 24.343 24.3363 24.343 23.7325V21.2332C24.343 20.6294 23.8517 20.1381 23.2479 20.1381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008670);
export default __webpack_public_path__ + "static/media/Group 1000008670.7060d6f56f53ae18f19a68b5af3c9831.svg";
export { ForwardRef as ReactComponent };